var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.rowClasses }, [
    _c("div", { staticClass: "gfu-compare-row__label" }, [_vm._t("label")], 2),
    _vm._v(" "),
    _c("div", { class: _vm.primaryCellClasses }, [
      _vm.effectivePrimaryLabel
        ? _c("div", { staticClass: "gfu-compare-row__cell-label" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.effectivePrimaryLabel) +
                "\n        "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "gfu-compare-row__cell-text" },
        [_vm._t("primary")],
        2
      ),
    ]),
    _vm._v(" "),
    _c("div", { class: _vm.secondaryCellClasses }, [
      _vm.effectiveSecondaryLabel
        ? _c("div", { staticClass: "gfu-compare-row__cell-label" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.effectiveSecondaryLabel) +
                "\n        "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "gfu-compare-row__cell-text" },
        [_vm._t("secondary")],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }